module.exports = __webpack_public_path__ + "static/media/user.ba2dd087.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/user.png
// module id = 1695
// module chunks = 0